import { useContext } from "react";

// GLOBAL STATES
import DataContext from "../globalstates/DataContext";

// ROUTER
import { useNavigate } from 'react-router-dom';

// IMAGE
import logoutIcon from '../pictures/icons/back_final.png';

import { defaultLogedIn } from "../App";

export default function LogOutBtn() {

    // ROUTER
    const navigate = useNavigate()
    
    // GLOBAL STATES
    const { setLoggedIn } = useContext(DataContext);

    // LOGOUT
    function logOut() {
        setLoggedIn(defaultLogedIn);
        navigate("/");
    }

    return(

        <div className="logoutbtn-container">
            <button 
            className="p-1"
            onClick={logOut}
            >
                <img width="50px" height="auto" src={logoutIcon}/>
            </button>
        </div>
    )
}